import { FormControl, Input, InputProps } from '@mr-yum/frontend-ui'
import React, { PropsWithChildren } from 'react'
import { useController } from 'react-hook-form'

import { HookFormControlProps, useErrorState } from './shared'

export type InputFieldProps = InputProps & HookFormControlProps

export const InputField = ({
  name,
  label,
  disabled,
  caption,
  ...props
}: PropsWithChildren<InputFieldProps>) => {
  const { field, fieldState } = useController({ name })
  const hasError = useErrorState(fieldState)

  return (
    <FormControl
      label={label}
      disabled={disabled}
      caption={caption}
      error={hasError ? fieldState.error?.message : null}
      htmlFor={name}
    >
      <Input
        {...props}
        {...field}
        error={hasError}
        value={field.value === null ? '' : field.value}
      />
    </FormControl>
  )
}
